import { Award } from 'lucide-react';

export function LoadingSpinner() {
  return (
    <div className="loading-screen min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/80 to-indigo-50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex items-center justify-center p-4">
      <div className="fixed inset-0 overflow-hidden pointer-events-none" aria-hidden>
        <div className="loading-screen-ambient absolute -top-40 -right-40 h-80 w-80 rounded-full bg-gradient-to-br from-blue-400/10 to-indigo-400/10 blur-3xl animate-float" />
        <div
          className="loading-screen-ambient absolute -bottom-40 -left-40 h-80 w-80 rounded-full bg-gradient-to-br from-emerald-400/10 to-teal-400/10 blur-3xl animate-float"
          style={{ animationDelay: '2s' }}
        />
      </div>

      <div className="loading-screen-enter relative z-10 w-full max-w-sm animate-scale-in rounded-3xl border border-white/60 bg-white/70 px-8 py-10 text-center shadow-soft backdrop-blur-md dark:border-slate-700/60 dark:bg-slate-900/70">
        <div className="relative mx-auto mb-6 inline-flex h-20 w-20 items-center justify-center">
          <div className="loading-screen-ring absolute inset-0 rounded-2xl border-2 border-emerald-500/25 border-t-emerald-500" />
          <div className="relative flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 shadow-lg shadow-emerald-500/20">
            <Award className="h-10 w-10 text-white" strokeWidth={1.75} />
          </div>
        </div>

        <h1
          className="loading-screen-enter mb-5 text-2xl font-semibold tracking-tight text-slate-800 dark:text-white animate-fade-in-up"
          style={{ animationDelay: '70ms', animationFillMode: 'both' }}
        >
          Rapid Cert
        </h1>

        <div className="flex items-center justify-center gap-1.5" role="status" aria-label="Loading">
          <span className="loading-screen-dot h-1.5 w-1.5 rounded-full bg-emerald-500" />
          <span className="loading-screen-dot h-1.5 w-1.5 rounded-full bg-emerald-500" />
          <span className="loading-screen-dot h-1.5 w-1.5 rounded-full bg-emerald-500" />
        </div>

        <p
          className="loading-screen-enter mt-4 text-sm text-slate-600 dark:text-slate-400 animate-fade-in-up"
          style={{ animationDelay: '130ms', animationFillMode: 'both' }}
        >
          Loading your workspace…
        </p>
      </div>
    </div>
  );
}
